<template>
    <div class="comments">
        <div v-for="(comment, key) in comments" :key="key">
            <!-- <template v-if="parent.userId">
                <span class="name" @click="$router.push(`/user/${comment.userId}`)">{{ comment.name }}</span>
                回复
                
                <span class="name" @click="$router.push(`/user/${parent.userId}`)">{{ parent.name }}</span>：
            </template>
            <template v-else>
                <span class="name" @click="$router.push(`/user/${comment.userId}`)">{{ comment.name }}</span>：
            </template> -->
             <template v-if="parent.userId">
                <span class="name" >{{ comment.name }}</span>
                回复
              
                <span class="name" >{{ parent.name }}</span>：
            </template>
            <template v-else>
                <span class="name" >{{ comment.name }}</span>：
            </template>
            <span v-html="comment.content" @click.stop="onClickComment(comments, comment, key)"></span>
            <!--<span class="name" @click="$router.push(`/user/${comment.userId}`)">{{ comment.name }}</span>：-->
            <!--<span v-html="comment.content" @click="onCommentClickey(comment, item)"></span>-->
            <span class="delete" @click="onDeleteComment(comments, comment, key)" v-if="comment.deleteSwitch || false">删除</span>
            <talk-comments-line :comments="comment.children" :parent="comment" :objectId="objectId" v-if="comment.children" @reply="$emit('reply', {comments, comment, key, objectId})"></talk-comments-line>
        </div>
    </div>
</template>

<script>
  import {Toast, Dialog} from 'vant';
  import TalkCommentsLine from '@/components/TalkCommentsLine';
  import Vue from 'vue'
  export default {
    name: 'TalkCommentsLine',
    components: {TalkCommentsLine},
    props: {
      isSelf: {
        type: Boolean,
        default: false
      },
      objectId: {
        type: String,
        require: true
      },
      comments: {
        type: Array,
        default: []
      },
      parent: {
        type: Object,
        default: () => {
          return {
            userId: '',
            name: ''
          };
        }
      }
    },
    methods: {
      onReply(comments, comment, key) {
        if (typeof comment.children === 'undefined') {
          comment.children = [];
        }
        this.$emit('reply', {comments, comment, key, objectId: this.objectId});
      },
      onClickComment(comments, comment, key) {
        if (this.isSelf || comment.userId === this.$store.state.userInfo.userId || this.$store.state.userInfo.isFrontAdmin) {
          // this.onDeleteComment(comments, comment, key);

          if (typeof comment.deleteSwitch === 'undefined') {
            Vue.set(comment, 'deleteSwitch', true);
          } else {
            comment.deleteSwitch = !comment.deleteSwitch;
          }
          if (comment.deleteSwitch) {
            setTimeout(() => {
              comment.deleteSwitch = false;
            }, 4500);
          }
          if (!this.isSelf) {
            return;
          }
        }
        this.onReply(comments, comment, key);
      },
      onDeleteComment(comments, item, key) {
        Dialog.confirm({
          message: '确定删除?'
        }).then(() => {
          this.$http.post('/comment/delete', {id: item.id}).then(() => {
            Toast('删除成功');
            comments.splice(key, 1);
          });
        }).catch(() => {
        });
      }
    }
  };
</script>

<style scoped lang="less">
    .comments {
        padding: 6px;
        text-align: left;
        border-top: 1px solid #eee;
        background-color: #f3f3f3;
        color: #707070;

        /deep/ img {
            zoom: .8;
            margin-bottom: -5px;
        }

        > div {
            position: relative;
            font-size: 13px;
            .name {
                color: cornflowerblue;
            }
            .delete {
                position: absolute;
                top: 2px;
                right: 2px;
                font-size: 12px;
                color: cornflowerblue;
            }
        }
    }
</style>